<template>
  <el-container class="container">
    <el-header class="header">
      <div class="title">
        <div
          v-if="isLogoVisible"
          class="img-box"
          @click="enterProjectList">
          <img :src="getLogoByTheme()" />
        </div>
        <!-- <div v-if="isLogoVisible" class="split-line"></div> -->
        <!-- <div class="name">控制台</div> -->
      </div>
      <userTooltip
        :userInfo="userInfo"
        :enterUserCenter="enterUserCenter" />
    </el-header>
    <el-container class="content">
      <!-- v-if="!isCollapse" -->
      <!-- :style="themeType==='stellar-light'?`backgroundImage: url('@/assets/img/aside1.png')`:''" -->

      <el-aside
        class="aside"
        v-if="showMenu"
        :width="isCollapse ? '112px' : '0'"
        :style="menuBackground"
        :class="`${isCollapse ? 'is-collapse' : 'is-expand'}`">
        <div class="common-navigation-menu">
          <el-menu
            router
            v-if="isNotMicroMode"
            :collapse="true"
            :default-active="activeMenu">
            <tree-menu
              v-for="(menu, index) in navMenuList"
              :key="index"
              :item="menu"
              :collapse="isCollapse" />
          </el-menu>
        </div>
        <!-- :style="`left:${isCollapse ? '88px' : '48px'}`" -->
        <template v-if="isCollapse">
          <div
            v-if="isNotMicroMode"
            class="collapse-btn-box"
            @click="toggleNavMenu">
            <i
              :class="`${
                isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'
              } icon`" />
          </div>
        </template>
      </el-aside>
      <div
        v-if="!isCollapse"
        class="collapse-btn-box-outer"
        @click="toggleNavMenu">
        <i
          :class="`${
            isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'
          } icon`" />
      </div>
      <el-main
        :style="`width:${isCollapse ? 'calc(100% - 144px)' : '0'}`"
        class="main"
        v-if="visible">
        <router-view />
        <personInfoPop v-if="isStarRiver" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import treeMenu from '../components/TreeMenu.vue'
import userTooltip from '../components/UserTooltip.vue'
import { navMenuDictionary } from '../utils/dictionary'
import EventBus from '@/utils/eventBus'
import { Store } from '@/utils/store'
import { isMicroAppMode } from '@/microAdapt/utils'
import { getToken, exitSystem } from '@/utils/generalMethods'
import personInfoPop from '@/layout/personInfoPop.vue'
import {
  getClientTokenService,
  getUserInfoByCenter,
  getRoleMenu,
  refreshTokenService
} from '@/service/interface'

export default {
  data() {
    return {
      isStarRiver: window.isStarRiver,
      isLogoVisible: window.isLogoVisible,

      isNotMicroMode: !isMicroAppMode(),
      userInfo: {},
      navMenuList: [],
      activeMenu: 'projectList',
      isCollapse: true,
      showMenu: true,
      visible: false,
      menuBackground: {}
    }
  },
  components: {
    treeMenu,
    userTooltip,
    personInfoPop
  },
  mounted() {
    EventBus.$on('changeTheme', themeName => {
      this.changeMenuBg(themeName)
    })
    EventBus.$on('updateUserPhone', () => {
      this.getUserInfo()
    })
    const themeName = this.$theme.get().value
    this.changeMenuBg(themeName)
  },
  created() {
    this.initClientInfo().then(() => {
      let path = this.$route.path
      let menuName = path.split('/')[1]
      this.activeMenu = menuName

      let token = this.getToken()
      if (!token) {
        if (window.isPrivate) {
          this.$router.push(`/privateLogin`)
        } else {
          this.$router.push(`/login`)
        }
      } else {
        let isDemoProj = JSON.parse(sessionStorage.getItem('isDemoProj'))
        if (isDemoProj) {
          this.refreshToken().then(() => {
            this.getUserInfo()
          })
        } else {
          this.getUserInfo()
        }
      }
    })
  },
  watch: {
    $route(to, from) {
      let menuName = to.path.split('/')[1]
      this.activeMenu = menuName
    }
  },
  methods: {
    changeMenuBg(themeName = 'stellar-light') {
      if (themeName === 'stellar-light') {
        this.menuBackground = {
          backgroundImage: `url(${require('@/assets/img/aside1.png')})`
        }
      } else if (themeName === 'dark') {
        this.menuBackground = {
          backgroundColor: `rgba(28, 28, 28, 1)`
        }
      }
    },

    initClientInfo() {
      return new Promise(resolve => {
        if (window.isClientAuthByRouter) {
          let { clientId, secretKey, userId } = this.$route.query
          secretKey = decodeURIComponent(secretKey)
          if (clientId && secretKey && userId) {
            this.initClientToken(clientId, secretKey, userId).then(() => {
              this.initClientPermission().then(() => {
                resolve()
              })
            })
          } else {
            resolve()
          }
        } else {
          resolve()
        }
      })
    },
    initClientToken(clientId, secretKey, userId) {
      return new Promise(resolve => {
        let params = { clientId, secretKey, userId }
        getClientTokenService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', response.token)
              sessionStorage.setItem('tokenId', response.tokenId)
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    initClientPermission() {
      return new Promise(resolve => {
        let params = { menuName: '' }
        getRoleMenu(params).then(res => {
          if (res.status === 200) {
            let response = res.data
            if (response.isSuccess) {
              let permissionData = response.data
              permissionData = this.treeToList(permissionData)
              Store.permissionData = permissionData
              resolve(permissionData)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    refreshToken() {
      return new Promise(resolve => {
        let oldToken = sessionStorage.getItem('oldToken')
        refreshTokenService({ token: oldToken }).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', oldToken)
              sessionStorage.removeItem('oldToken')
              sessionStorage.removeItem('isDemoProj')
            } else {
              sessionStorage.removeItem('oldToken')
              sessionStorage.removeItem('isDemoProj')
              this.$message({
                message: '登录信息已过期，请重新登录!',
                type: 'error',
                duration: 3 * 1000
              })
              if (window.isCloseTab) {
                exitSystem()
              } else {
                if (window.isPrivate) {
                  this.$router.push('/privateLogin')
                } else {
                  this.$router.push('/login')
                }
                window.location.reload()
              }
            }
          }
          resolve()
        })
      })
    },
    toggleNavMenu() {
      this.isCollapse = !this.isCollapse
    },
    enterUserCenter() {
      this.$router.push('./userCenter')
    },
    enterProjectList() {
      this.$router.push('./projectList')
    },
    getUserInfo() {
      this.getUserPermission().then(() => {
        if (this.isChecked('User.CenterQuery')) {
          getUserInfoByCenter().then(res => {
            if (res.status === 200) {
              let data = res.data
              if (data.isSuccess) {
                let userInfo = data.data
                Store.userInfo = userInfo
                this.userInfo = userInfo
                this.visible = true
              } else {
                this.$message.error(data.errMsg)
              }
            }
          })
        }
      })
    },
    getUserPermission() {
      return new Promise(resolve => {
        let params = {
          menuName: ''
        }
        getRoleMenu(params).then(res => {
          if (res.status === 200) {
            let data = res.data
            if (data.isSuccess) {
              let permissionData = data.data
              let navMenuList = this.getNavMenuList(permissionData)
              if (navMenuList.length > 1) {
                this.showMenu = true
              } else {
                this.showMenu = false
              }
              this.navMenuList = navMenuList
              permissionData = this.treeToList(permissionData)
              Store.permissionData = permissionData
              resolve()
            }
          }
        })
      })
    },
    getNavMenuList(permissionData) {
      let mainMenu = JSON.parse(JSON.stringify(permissionData[0]))
      let navMenuList = []
      if (mainMenu.childNodes) {
        navMenuList = mainMenu.childNodes.map(item => {
          if (item.permissionCode === 'Data.Migration') {
            item.childNodes = []
          } else if (item.permissionCode === 'Project.OfflinePackageManage') {
            item.childNodes = []
          } else {
            if (item.childNodes && item.childNodes.length > 1) {
              item.childNodes.forEach(el => {
                if (el.childNodes) {
                  el.childNodes = []
                }
              })
            } else {
              item.childNodes = []
            }
          }

          return item
        })
      }

      navMenuDictionary.forEach(item => {
        let menu = this.findMenuByMenuName(navMenuList, item)
        if (menu) {
          menu['iconPath'] = item.iconPath
          menu['iconInfo'] = item.iconInfo
          menu['pageUrl'] = item.pageUrl
        }
      })
      navMenuList = navMenuList.filter(el => el.isCheck)
      return navMenuList
    },
    treeToList(permissionData) {
      let queue = []
      let out = []
      queue = queue.concat(permissionData)
      while (queue.length) {
        let first = queue.shift()
        if (first.childNodes) {
          queue = queue.concat(first.childNodes)
          delete first['childNodes']
        }
        out.push(first)
      }
      return out
    },
    findMenuByMenuName(data, dictionary) {
      for (const node of data) {
        let permissionCode = node.permissionCode
        if (permissionCode && permissionCode === dictionary.permissionCode) {
          return node
        }
        if (node.menuName === dictionary.menuName) return node
        if (node.childNodes && node.childNodes.length) {
          const res = this.findMenuByMenuName(node.childNodes, dictionary)
          if (res) return res
        }
      }
      return null
    },
    getLogoByTheme() {
      const themeName = this.$theme.get().value
      let thumbnail
      switch (themeName) {
        case 'stellar-light':
          thumbnail = require('@/assets/logo/logo_light.png')
          break
        case 'dark':
          thumbnail = require('@/assets/logo/logo_dark.png')
          break
      }
      return thumbnail
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getToken
  },
  computed: {
    themeType() {
      return this.$theme.get().value || 'stellar-light'
    }
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');
.container {
  height: 100%;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 16px;
    background: var(--header-bg-color);
    height: 64px;

    .title {
      display: flex;

      .img-box {
        height: 28px;
        width: 138px;
        margin: auto;
        cursor: pointer;

        img {
          height: 100%;
        }
      }

      .split-line {
        width: 2px;
        height: 30px;
        margin: 15px;
        background: var(--base-border-primary-color);
      }

      .name {
        line-height: 55px;
        font-size: 24px;
      }
    }
  }

  .content {
    height: calc(100% - 76px);
    margin-top: 16px;

    .aside {
      position: relative;
      height: 100%;
      margin-right: 16px;
      border-top-right-radius: 16px;
      overflow-x: hidden;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      overflow-y: hidden;

      .common-navigation-menu {
        height: calc(100% - 80px);
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox 64+ 隐藏滚动条 */
        -ms-overflow-style: none; /* IE/Edge 隐藏滚动条 */
        &::-webkit-scrollbar {
          width: 0; /* 滚动条宽度设为0 */
          background: transparent; /* 可选：让轨道透明 */
        }

        .el-menu {
          background: none;
        }
      }

      .collapse-btn-box {
        margin: 30px 0 20px 50%;
        transform: translateX(-50%);
        width: 32px;
        height: 32px;
        background: var(--aside-collapse-bgColor);
        border-radius: 8px;
        cursor: pointer;
        z-index: 1;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: var(--aside-collapse-hover-bgColor);
        }

        &:active {
          background: var(--aside-collapse-active-bgColor);
        }

        .icon {
          vertical-align: middle;
          color: var(--aside-collapse-icon-color);
        }
      }

      // .el-menu {
      //   background: linear-gradient(24deg, var(--base-bg-light-color21) 0%, var(--base-bg-light-color22) 47%, var(--base-bg-light-color23) 100%);
      // }

      :deep(.el-submenu) {
        padding: 12px 16px 0 16px;

        .el-submenu__title {
          width: 100%;
          height: 100%;
          line-height: inherit;
          border-radius: 12px;

          &:hover {
            border-radius: 12px;
            background: var(--aside-menu-hover-bgColor);
          }

          &:active {
            border-radius: 12px;
            background: var(--aside-menu-active-bgColor);
          }

          .common-submenu-box-title {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 16px !important;
            border: 1px solid transparent;

            &-active {
              border-radius: 12px;
              background: var(--aside-menu-active-bgColor);
              border: 1px solid var(--aside-menu-border-color);
            }
          }
        }
      }
    }

    .collapse-btn-box-outer {
      position: fixed;
      bottom: 18px;
      left: 18px;
      width: 32px;
      height: 32px;
      background: var(--base-primary-bgColor);
      // background: #333;
      border-radius: 8px;
      cursor: pointer;
      z-index: 999;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--aside-bg-color);
      box-shadow: var(--base-bg-dark-color30);

      &:hover {
        background: var(--base-primary-bgColor);
        border-radius: 8px;
      }

      &:active {
        background: var(--base-primary-bgColor);
        border-radius: 8px;
      }

      .icon {
        vertical-align: middle;
        width: 14px;
        height: 14px;
      }
    }

    .is-collapse,
    .is-expand {
      transition: all 0.3s;
    }

    .main {
      padding: 0px;
      margin-right: 16px;
      margin-bottom: 16px;

      &:not(:has(.element-manage-container)) {
        overflow: hidden;
        border-radius: 16px;
        // box-shadow: var(--base-bg-dark-color30);
        background-color: var(--base-bg-light-color49);
      }

      &:has(.element-manage-container) {
        overflow: visible;
      }
      &:has(.orderDetail) {
        background-color: transparent;
        box-shadow: none;
      }

      &:has(.sass-config-container),
      &:has(.private-config-container),
      &:has(.team-manage-box),
      &:has(.proj-auth-box) {
        overflow: visible;
      }

      // &:has(.nobg){
      //   background-color: transparent;
      // }

      &:has(.permission-manage) {
        // overflow: visible;
      }
    }
  }
}
</style>
